import { pbxSettingsEn } from './en'

export const pbxSettingsEnGb = pbxSettingsEn
